import type { FormStepId } from 'shared/config/formStepId';

import type { ISingleOrderStep } from 'widgets/AnketaWidget';

import { useValidateData } from './useValidateData';
import type { TStepsValidateErrors } from './validateUserDataThunk';

export const useInitialValidation = (
  targetStep?: ValuesOf<typeof FormStepId>,
  allSteps: ISingleOrderStep[] = [],
  onValidationComplete?: (step?: ValuesOf<typeof FormStepId>) => void,
) => {
  const stepsToValidate = targetStep
    ? allSteps
        .map((s) => s.formId)
        .slice(
          0,
          allSteps.findIndex((s) => s.formId === targetStep),
        )
    : [];

  const onSuccess = () => {
    onValidationComplete?.(targetStep);
  };

  const onError = (stepsValidateErrors: TStepsValidateErrors) => {
    const firstErrorStep = stepsValidateErrors[0];
    onValidationComplete?.(firstErrorStep.formStepId);
  };

  return useValidateData(
    {
      onSuccess,
      onError,
    },
    !!targetStep,
    stepsToValidate,
  );
};
